(function(){
function fmt(c){ return Math.round(c/100) + ' kr'; }
function data(){ return window.cilleCartData || null; }
function drawer(){ return document.querySelector('cart-drawer'); }
function imgUrl(pid){
  var m = window.cilleCartImgs || {};
  var p = m[String(pid)];
  if(!p) return '';
  var full = p.indexOf('http') === 0 ? p : (window.cilleCartImgPre || '') + p;
  return full + (full.indexOf('?') > -1 ? '&width=140' : '?width=140');
}

/* ---------------------------------------------------------------------------
   PRISTRAPPAN  (148 kr-modellen, doc 107 — live 27 aug 2026)
   1 st 148 kr + 54 kr frakt = 202 · 3 st 399 fri frakt · 5 st 599 fri frakt
   Fri frakt-gränsen i Shopify shipping är 399 kr.
   Trappan finns på TRE ställen och måste ändras på alla tre:
   assets/cille-cart.js · assets/cille-product.js · snippets/cille-set.liquid
--------------------------------------------------------------------------- */
var TIERS = [{n:3,p:399,off:4500,fs:true},{n:5,p:599,off:14100,fs:true}];
var MAXN = 5;
var FS_MIN = 39900, FS_COST = 5400, UNIT = 14800;
var CREAM = '#FFF6EE';

(function(){
  var s = document.createElement('style');
  s.textContent = [
    'cart-drawer .cc-mtxt .hl{display:block;line-height:1.35;}',
    'cart-drawer .cc-mtxt .sb,cart-drawer .cc-fill,cart-drawer .cc-save,cart-drawer .cc-trust{display:none !important;}',
    'cart-drawer #CartDrawer-Checkout,cart-drawer .cart__checkout-button{font-size:17.5px!important;font-weight:800!important;letter-spacing:.01em!important;line-height:1.2!important;padding-top:17px!important;padding-bottom:17px!important;min-height:56px!important;}',
    '@media(max-width:420px){cart-drawer #CartDrawer-Checkout,cart-drawer .cart__checkout-button{font-size:16.5px!important;}}',
    /* Papperskorgen satt i mörk bordeaux mot rosa cirkel — knappt synlig. Kräm. */
    'cart-drawer cart-remove-button,cart-drawer cart-remove-button button,cart-drawer .cart-item__remove,cart-drawer .cart-remove-button,cart-drawer [id^="Remove-"]{color:' + CREAM + '!important;}',
    'cart-drawer cart-remove-button svg,cart-drawer .cart-item__remove svg,cart-drawer .cart-remove-button svg,cart-drawer [id^="Remove-"] svg{color:' + CREAM + '!important;}'
  ].join('');
  document.head.appendChild(s);
})();

/* CSS räcker inte alltid: många tema-ikoner har stroke/fill hårdkodat som attribut
   på själva path:en, vilket slår CSS. Därför målas de om explicit — men bara
   där ett värde redan finns, så att fill="none" förblir none och konturikoner
   inte blir solida klumpar. */
function paintRemove(root){
  if(!root) return;
  var btns = root.querySelectorAll('cart-remove-button, .cart-item__remove, .cart-remove-button, [id^="Remove-"]');
  Array.prototype.forEach.call(btns, function(b){
    b.style.color = CREAM;
    Array.prototype.forEach.call(b.querySelectorAll('svg, svg *'), function(n){
      if(n.style) n.style.color = CREAM;
      var st = n.getAttribute && n.getAttribute('stroke');
      if(st && st !== 'none') n.setAttribute('stroke', CREAM);
      var fl = n.getAttribute && n.getAttribute('fill');
      if(fl && fl !== 'none') n.setAttribute('fill', CREAM);
    });
  });
}

/* PATCH: Leverans-raden i sections/cille-product.liquid är hårdkodad med den
   gamla frigränsen ("fri frakt över 499 kr"). Den sektionen är 31 kB och
   innehåller 30+ video-URL:er, så den skrivs inte om härifrån — raden rättas
   istället i DOM:en. Rätta gärna i Liquid nästa gång sektionen ändå ska röras,
   och ta då bort det här blocket. */
(function(){
  function fixShip(){
    var nodes = document.querySelectorAll('.pp-tl span, .pp-a span, .pp-micro');
    Array.prototype.forEach.call(nodes, function(s){
      var h = s.innerHTML;
      if(h.indexOf('499') === -1) return;
      var n = h.replace(/fri frakt över 499 kr/gi, 'fri frakt från 399 kr')
               .replace(/Fri frakt över 499 kr/g, 'Fri frakt från 399 kr');
      if(n !== h) s.innerHTML = n;
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fixShip); } else { fixShip(); }
  window.addEventListener('load', fixShip);
})();

var NOT_JEWEL = ['mystisk','gift box','fraktförsäkring','fraktforsakring'];
function isJewel(it){
  if(!it) return false;
  if(it.gift_card) return false;
  if(it.requires_shipping === false) return false;
  if(!it.price || it.price <= 0) return false;
  var t = String(it.product_type || '').toLowerCase();
  if(t.indexOf('shipping protection') > -1 || t.indexOf('shopwill') > -1) return false;
  var name = String(it.product_title || it.title || '').toLowerCase();
  for(var i = 0; i < NOT_JEWEL.length; i++){ if(name.indexOf(NOT_JEWEL[i]) > -1) return false; }
  return true;
}
function jewels(cart){ return (cart && cart.items ? cart.items : []).filter(isJewel); }
function jewelCount(cart){ return jewels(cart).reduce(function(n, it){ return n + (it.quantity || 0); }, 0); }
function allStd(cart){ var j = jewels(cart); return j.length > 0 && j.every(function(it){ return it.price === UNIT; }); }

function orderOff(n){ return n >= 5 ? 14100 : (n >= 3 ? 4500 : 0); }
var NEED_WORD = ['Tre','Två','Ett'];
function ladderCopy(n, std){
  var line = function(a){ return '<span class="hl">' + a + '</span>'; };
  if(!std){
    if(n >= 3) return line('Setpris upplåst ✓ · fri frakt ingår');
    return line('Lägg till ' + (3 - n) + ' till → setpris + fri frakt');
  }
  if(n >= 5) return line('<b>5 för 599 kr</b> ✓ · fri frakt ingår');
  if(n === 4) return line('Ett till → <b>5 för 599 kr</b>');
  if(n === 3) return line('<b>3 för 399 kr</b> ✓ · två till → <b>5 för 599 kr</b>');
  return line((NEED_WORD[n] || (3 - n)) + ' till → <b>3 för 399 kr</b> + fri frakt');
}
function meterHtml(cart){
  var n = jewelCount(cart), std = allStd(cart);
  var nxt = null;
  TIERS.forEach(function(t){ if(n < t.n && !nxt){ nxt = t; } });
  var pct = Math.min(100, Math.round(n/MAXN*100));
  var nodes = '';
  TIERS.forEach(function(t){
    var st = n >= t.n ? ' done' : (nxt && nxt.n === t.n ? ' next' : '');
    nodes += '<span class="cc-ln' + st + '" style="left:' + Math.round(t.n/MAXN*100) + '%"><i>' + (n >= t.n ? '✓' : t.n) + '</i><em>' + t.p + ' kr</em></span>';
  });
  return '<div class="cc-meter cc-ladder' + (n >= MAXN ? ' cc-unlocked' : '') + (n === 4 && std ? ' cc-near' : '') + '">' +
    '<div class="cc-mtxt">' + ladderCopy(n, std) + '</div>' +
    '<div class="cc-lad"><div class="cc-mbar"><i style="width:' + pct + '%"></i></div>' + nodes + '</div>' +
    '</div>';
}

function pickUpsells(cart){
  var D = data(); if(!D) return [];
  var inCart = {};
  cart.items.forEach(function(it){ inCart[String(it.product_id)] = true; });
  var seen = {}, out = [];
  for(var round = 0; round < 4; round++){
    cart.items.forEach(function(it){
      var partners = D.map[String(it.product_id)] || [];
      var pid = partners[round];
      if(!pid || inCart[pid] || seen[pid]) return;
      var c = D.cat[pid];
      if(!c) return;
      seen[pid] = true;
      out.push({ pid: pid, t: c.t, p: c.p, v: c.v });
    });
  }
  return out.slice(0, 4);
}

function upsHtml(ups){
  ups = ups.slice(0, 3);
  if(!ups.length) return '';
  var h = '<div class="cc-ups"><div class="cc-ups-t">STYLA DIN LOOK ✦ <span>· kunder köper ofta ihop</span></div><div class="cc-ups-row">';
  ups.forEach(function(u){
    var iu = imgUrl(u.pid);
    h += '<div class="cc-up">' + (iu ? '<img class="cc-up-img" src="' + iu + '" alt="' + u.t + '" loading="lazy" width="52" height="52">' : '<span class="cc-up-img"></span>') + '<div class="cc-up-b"><b>' + u.t + '</b><span>' + u.p + ' kr</span></div><button type="button" class="cc-up-add" data-v="' + u.v + '" aria-label="Lägg till ' + u.t + '">+</button></div>';
  });
  return h + '</div></div>';
}

function footHtml(total){
  return '<div class="cc-klarna"><span class="cc-kb">Klarna.</span><p>Dela upp i 3 betalningar à ' + (total/300).toFixed(2).replace('.',',') + ' kr — räntefritt</p></div>';
}

function totalsRows(inner, cart){
  var tot = inner.querySelector('.cart-drawer__totals');
  if(!tot) return;
  var shipFree = cart && cart.total_price >= FS_MIN;
  var saved = (cart && cart.total_discount) || 0;
  Array.prototype.forEach.call(tot.querySelectorAll('.cc-trow'), function(el){ el.remove(); });
  if(!shipFree) return;
  var delsum = null;
  Array.prototype.forEach.call(tot.children, function(p){
    var lbl = p.firstElementChild ? p.firstElementChild.textContent.trim() : '';
    if(/delsumma/i.test(lbl)){ delsum = p; }
  });
  if(!delsum) return;
  var mk = function(label, value, strong){
    var p = delsum.cloneNode(true);
    p.className = delsum.className + ' cc-trow';
    var k = p.children;
    if(k[0]){ k[0].textContent = label; }
    if(k[1]){ k[1].textContent = value; }
    for(var i = 0; i < k.length; i++){
      k[i].style.color = strong ? '#14584A' : '#1E7A63';
      k[i].style.fontWeight = strong ? '900' : '700';
      k[i].style.fontFamily = strong ? '' : "'Figtree',sans-serif";
      k[i].style.fontSize = strong ? '' : '14px';
    }
    return p;
  };
  tot.insertBefore(mk('Frakt', 'GRATIS – spara ' + fmt(FS_COST), false), delsum);
  if(saved > 0){ tot.insertBefore(mk('Du sparar', '-' + fmt(saved + FS_COST), true), delsum); }
}

function inject(cart){
  var dr = drawer(); if(!dr) return;
  var inner = dr.querySelector('.drawer__inner'); if(!inner) return;
  paintRemove(inner);
  var co = inner.querySelector('#CartDrawer-Checkout, .cart__checkout-button');
  if(co && co.getAttribute('name') !== 'checkout'){ co.setAttribute('name', 'checkout'); }
  Array.prototype.forEach.call(inner.querySelectorAll('.cart-drawer__totals strong'), function(el){
    if(el.textContent.trim() === 'Du sparar'){ el.textContent = 'Rabatt'; }
  });
  totalsRows(inner, cart);
  if(!cart || cart.item_count === 0){
    ['.cc-top','.cc-ups','.cc-foot'].forEach(function(s){ var el = inner.querySelector(s); if(el) el.remove(); });
    return;
  }
  var hdr = inner.querySelector('.drawer__header');
  var top = inner.querySelector('.cc-top');
  if(!top){ top = document.createElement('div'); top.className = 'cc-top'; if(hdr){ hdr.insertAdjacentElement('afterend', top); } else { inner.insertAdjacentElement('afterbegin', top); } }
  top.innerHTML = meterHtml(cart);
  var body = inner.querySelector('.cart-drawer__body');
  var upsEl = inner.querySelector('.cc-ups');
  if(upsEl) upsEl.remove();
  var ups = pickUpsells(cart);
  if(body && ups.length){ body.insertAdjacentHTML('beforeend', upsHtml(ups)); }
  var foot = inner.querySelector('.drawer__footer');
  if(foot){
    var cf = foot.querySelector('.cc-foot');
    if(!cf){ cf = document.createElement('div'); cf.className = 'cc-foot'; foot.insertAdjacentElement('afterbegin', cf); }
    cf.innerHTML = footHtml(cart.total_price);
  }
}

function openDrawer(){
  var dr = drawer(); if(!dr) return;
  dr.classList.remove('is-empty');
  if(typeof dr.open === 'function'){ try { dr.open(); } catch(e){} }
  dr.classList.add('active', 'animate');
  document.body.classList.add('overflow-hidden');
}

function refreshAll(keepOpen){
  return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function(r){ return r.json(); }).then(function(secs){
      var dr = drawer();
      var wasOpen = dr && (dr.classList.contains('active') || keepOpen);
      if(dr && secs['cart-drawer']){
        var tmp = document.createElement('div');
        tmp.innerHTML = secs['cart-drawer'];
        var fresh = tmp.querySelector('cart-drawer');
        if(fresh){ dr.className = fresh.className; dr.innerHTML = fresh.innerHTML; }
      }
      var bub = document.getElementById('cart-icon-bubble');
      if(bub && secs['cart-icon-bubble']){ var t2 = document.createElement('div'); t2.innerHTML = secs['cart-icon-bubble']; var fb = t2.querySelector('#shopify-section-cart-icon-bubble') || t2.firstElementChild; if(fb) bub.innerHTML = fb.innerHTML; }
      inject(cart);
      if(wasOpen){ openDrawer(); }
      return cart;
    });
  }).catch(function(){});
}

window.cilleCartOpen = function(){ return refreshAll(true); };

document.addEventListener('submit', function(e){
  var f = e.target;
  if(!f || f.tagName !== 'FORM') return;
  if(f.id === 'ppForm') return;
  var action = (f.getAttribute('action') || '');
  if(action.indexOf('/cart/add') === -1) return;
  e.preventDefault();
  e.stopPropagation();
  var btn = f.querySelector('button[type="submit"], [type="submit"]');
  var old = btn ? btn.innerHTML : '';
  if(btn){ btn.disabled = true; }
  var fd = new FormData(f);
  fetch('/cart/add.js', { method: 'POST', body: fd, headers: {'Accept': 'application/json'} })
    .then(function(r){ if(!r.ok) throw new Error('add failed'); return (window.cilleCartOpen ? window.cilleCartOpen() : null); })
    .then(function(){ if(btn){ btn.disabled = false; btn.innerHTML = old; } })
    .catch(function(){ if(btn){ btn.disabled = false; btn.innerHTML = old; } });
}, true);

document.addEventListener('click', function(e){
  var co = e.target.closest ? e.target.closest('#CartDrawer-Checkout, cart-drawer .cart__checkout-button') : null;
  if(co){ e.preventDefault(); e.stopPropagation(); window.location.href = '/checkout'; return; }
  var btn = e.target.closest ? e.target.closest('.cc-up-add') : null;
  if(!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if(btn.disabled) return;
  btn.disabled = true; btn.textContent = '…';
  fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.v, 10), quantity: 1 }] }) })
    .then(function(r){ if(!r.ok) throw new Error('add failed'); return refreshAll(true); })
    .catch(function(){ btn.disabled = false; btn.textContent = '+'; });
}, true);

var pending = null;
function scheduleInject(){
  if(pending) return;
  pending = setTimeout(function(){
    pending = null;
    var dr = drawer();
    if(!dr) return;
    paintRemove(dr);
    if(dr.querySelector('.cc-meter')) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(inject).catch(function(){});
  }, 200);
}

function boot(){
  var dr = drawer();
  if(!dr) return;
  paintRemove(dr);
  fetch('/cart.js').then(function(r){ return r.json(); }).then(inject).catch(function(){});
  new MutationObserver(scheduleInject).observe(dr, { childList: true, subtree: true });
}
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }

(function(){
  var me = document.currentScript || (function(){ var a = document.querySelectorAll('script[src*="cille-cart.js"]'); return a[a.length-1]; })();
  if(!me || !me.src) return;
  var CS_V = 'cs5';
  var url = me.src.split('?')[0].replace('cille-cart.js', 'cille-size.js') + '?v=' + CS_V;
  var s2 = document.createElement('script'); s2.src = url; s2.defer = true;
  document.head.appendChild(s2);
})();
})();
